import React from 'react';

export default function BlogLayout({ children, title, description }) {
  React.useEffect(() => {
    if (title) document.title = title + ' — Integra MKP';
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute('content', description);
    // RSS auto-discovery
    let rssLink = document.querySelector('link[type="application/rss+xml"]');
    if (!rssLink) {
      rssLink = document.createElement('link');
      rssLink.setAttribute('rel', 'alternate');
      rssLink.setAttribute('type', 'application/rss+xml');
      rssLink.setAttribute('title', 'Integra MKP Blog');
      rssLink.setAttribute('href', 'https://integramkp.com.br/feed.xml');
      document.head.appendChild(rssLink);
    }
    return () => { rssLink?.remove(); };
  }, [title, description]);

  React.useEffect(() => {
    const prev = document.body.style.overflow;
    const rootPrev = document.getElementById('root')?.style.overflow;
    const rootHeightPrev = document.getElementById('root')?.style.height;
    document.body.style.overflow = 'auto';
    const root = document.getElementById('root');
    if (root) { root.style.overflow = 'auto'; root.style.height = 'auto'; }
    return () => {
      document.body.style.overflow = prev;
      if (root) { root.style.overflow = rootPrev || ''; root.style.height = rootHeightPrev || ''; }
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#FAF8F3', fontFamily: "'Inter', sans-serif", color: '#0E1430' }}>
      {/* Header */}
      <header style={{ background: '#fff', borderBottom: '1px solid #E4E0D4', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px', height: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 900, fontSize: 22, color: '#1B2A7A' }}>
              Integra<span style={{ color: '#FFC700' }}>M</span><span style={{ color: '#E63946' }}>K</span><span style={{ color: '#2E7DE0' }}>P</span>
            </span>
          </a>
          <nav style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
            <a href="/blog" style={{ textDecoration: 'none', color: '#3B4266', fontSize: 14, fontWeight: 500 }}>Blog</a>
            <a href="/sobre" style={{ textDecoration: 'none', color: '#3B4266', fontSize: 14, fontWeight: 500 }}>Sobre</a>
            <a href="/" style={{ textDecoration: 'none', background: '#1B2A7A', color: '#fff', padding: '8px 18px', borderRadius: 8, fontSize: 14, fontWeight: 600 }}>Testar grátis</a>
          </nav>
        </div>
      </header>

      {/* Content */}
      <main>{children}</main>

      {/* Footer */}
      <footer style={{ borderTop: '1px solid #E4E0D4', marginTop: 80, background: '#fff', padding: '40px 24px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
          <span style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 900, fontSize: 18, color: '#1B2A7A' }}>
            Integra<span style={{ color: '#FFC700' }}>M</span><span style={{ color: '#E63946' }}>K</span><span style={{ color: '#2E7DE0' }}>P</span>
          </span>
          <nav style={{ display: 'flex', gap: 24, flexWrap: 'wrap', justifyContent: 'center' }}>
            {[['/', 'Início'], ['/blog', 'Blog'], ['/sobre', 'Sobre'], ['/privacidade', 'Privacidade'], ['/contato', 'Contato'], ['/feed.xml', 'RSS']].map(([href, label]) => (
              <a key={href} href={href} style={{ textDecoration: 'none', color: '#6A7091', fontSize: 13 }}>{label}</a>
            ))}
          </nav>
          <p style={{ color: '#9CA3AF', fontSize: 12, textAlign: 'center' }}>
            © {new Date().getFullYear()} Integra MKP — Dashboard para vendedores do Mercado Livre.<br />
            Integra MKP não é afiliado ao Mercado Livre.
          </p>
        </div>
      </footer>
    </div>
  );
}
